export function toTopLevelStepPath(threadIndex, stepIndex) {
    return `/threads/${threadIndex}/steps/${stepIndex}`;
}
export function buildLoopContinuationPathRelocations(threadIndex, currentStepCounter) {
    const ownerMacroPath = toTopLevelStepPath(threadIndex, currentStepCounter);
    return [
        {
            fromStepPath: `${ownerMacroPath}/case/what`,
            toStepPath: toTopLevelStepPath(threadIndex, currentStepCounter + 1),
        },
        {
            fromStepPath: `${ownerMacroPath}/case/when`,
            toStepPath: toTopLevelStepPath(threadIndex, currentStepCounter + 2),
        },
    ];
}
export function buildBranchContinuationPathRelocations(threadIndex, currentStepCounter, branchCaseIndex) {
    const ownerMacroPath = toTopLevelStepPath(threadIndex, currentStepCounter);
    const casePathPrefix = `${ownerMacroPath}/cases/${branchCaseIndex}`;
    return [
        {
            fromStepPath: `${casePathPrefix}/when`,
            toStepPath: toTopLevelStepPath(threadIndex, currentStepCounter + 1),
        },
        {
            fromStepPath: `${casePathPrefix}/what`,
            toStepPath: toTopLevelStepPath(threadIndex, currentStepCounter + 2),
        },
    ];
}
export function nullMacroStepContext() {
    return {
        ownerMacroStepPath: null,
        slotInOwner: null,
        ownerCaseIndex: null,
    };
}
export function resolveMacroStepContextForToolStep(mutableWorkflow, stepKey) {
    for (const [threadIndex, steps] of mutableWorkflow.stepsByThreadIndex.entries()) {
        for (const [stepIndex, step] of steps.entries()) {
            const ownerMacroStepPath = toTopLevelStepPath(threadIndex, stepIndex);
            if (step.stepKind === 'for' || step.stepKind === 'while') {
                if (step.case.when.stepKey === stepKey) {
                    return {
                        ownerMacroStepPath,
                        slotInOwner: 'case/when',
                        ownerCaseIndex: null,
                    };
                }
                if (step.case.what.stepKey === stepKey) {
                    return {
                        ownerMacroStepPath,
                        slotInOwner: 'case/what',
                        ownerCaseIndex: null,
                    };
                }
                continue;
            }
            if (step.stepKind === 'branch') {
                for (const [caseIndex, branchCase] of step.cases.entries()) {
                    if (branchCase.when.stepKey === stepKey) {
                        return {
                            ownerMacroStepPath,
                            slotInOwner: 'cases/when',
                            ownerCaseIndex: caseIndex,
                        };
                    }
                    if (branchCase.what.stepKey === stepKey) {
                        return {
                            ownerMacroStepPath,
                            slotInOwner: 'cases/what',
                            ownerCaseIndex: caseIndex,
                        };
                    }
                }
            }
        }
    }
    return nullMacroStepContext();
}
export function stampAndAppendTracePoint(state, threadIndex, ev) {
    const prev = state.tracePointIndexCounters?.[threadIndex] ?? -1;
    const next = prev + 1;
    const stamped = {
        ...ev,
        tracePointIndex: next,
    };
    return {
        tracePoints: [stamped],
        tracePointIndexCounters: {
            ...(state.tracePointIndexCounters ?? {}),
            [threadIndex]: next,
        },
    };
}
